module.exports = __webpack_public_path__ + "static/img/莲藕数字健康云商家后台.811ab47d.png";